/* eslint-disable */

export default {
  SET_PLACE_FROM: (state, payload) => {
    state.placeFrom = payload;
  },
  SET_PLACE_TO: (state, payload) => {
    state.placeTo = payload;
  },
  SET_TRANSLATIONS: (state, payload) => {
    state.translations = payload;
  },
  SET_VIEW_SIZE: (state, payload) => {
    state.viewSize = payload;
  },
  SET_GLOBAL_ERROR: (state, payload) => {
    state.globalError = payload;
  },
  SET_OPERATION_ERROR: (state, payload) => {
    state.operationError = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js